import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { sexoKeyToLabel } from "../../../detalhes-do-projeto/filtros/sexo"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import WcIcon from '@mui/icons-material/Wc'

export const RecorteSexoFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeCreateRecorteFormFiltros } = useRecortesExtracaoService()

    const handleRemoveFilter = () => {
        removeCreateRecorteFormFiltros({ filtro: 'sexo' });
    };


    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Sexo
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={handleRemoveFilter}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {createRecorteExtracaoForm.fields.Filtros &&
                        createRecorteExtracaoForm.fields.Filtros.sexo && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {createRecorteExtracaoForm.fields.Filtros.sexo.map((sexo, i) => (
                                        <Chip
                                            key={i}
                                            icon={<WcIcon />}
                                            label={sexoKeyToLabel(sexo).toUpperCase()}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}